import React, { HTMLAttributes } from "react";
import cn from "classnames";

export type CardFooterProps = HTMLAttributes<HTMLDivElement>;

export const CardFooter = (props: CardFooterProps) => {
  const { className, ...rest } = props;
  return <div className={cn("card-footer", className)} {...rest} />;
};

export default CardFooter;
